import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlKaraleePage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["karalee"]} />;
}
